"use strict";
ui.loadTemplateFile("chatbox.html");

import { GCM } from "../../js/helpers/chatmanager";

class ChatBox extends Dialog {
    _element: any;
    _titleBar: any;
    _game: any;
    _system: any;
    _category: any;
    _text: any;

    constructor() {
        super("chatbox.html");

        this._game = ui.label(this, ".label.game.messages");
        this._system = ui.label(this, ".label.system.messages");
        this._category = ui.radiogroup(this, ".radiogroup.chat-type");
        this._text = ui.textbox(this, ".textbox.message");

        this._text.on("returnpressed", this._sendMessage.bind(this));
        this._category.on("itemclicked", this._setCategory.bind(this));
        ui.button(this, ".button.send").on("clicked", this._sendMessage.bind(this));

        GCM.on("game_message", this._onGameMessage.bind(this));
        GCM.on("system_message", this._onSystemMessage.bind(this));

        // Focus chat input when Enter is pressed globally
        $(document).on("keydown", this._onGlobalKeyDown.bind(this));
    }

    _onGlobalKeyDown(event: any) {
        // Focus chat input when Enter is pressed, unless already focused
        if (event.keyCode === ui.KEY_CODES.ENTER) {
            const target = $(event.target);
            // Only focus if not already in a text input/textarea
            if (!target.is("input") && !target.is("textarea")) {
                this._text.focus();
            }
        }
    }

    _onGameMessage(message: any) {
        let html = '<div class="' + GCM.types[message.type].name + '">';
        html += message.sender.name + "&gt; ";
        html += message.message;
        html += "</div>";
        this._game.append(html);
        this._game.scrollToBottom();
    }

    _onSystemMessage(message: any) {
        let html = '<div class="' + GCM.types[message.type].name + '">';
        html += message.message;
        html += "</div>";
        this._system.append(html);
        this._system.scrollToBottom();
    }

    _setCategory(index: any) {
        const categories = ["", "$", "@", "#", '"', "~"];
        this._text.text(categories[index]);
    }

    _sendMessage() {
        const message = this._text.text();
        let reset = message[0];
        let sent;

        switch (message[0]) {
            case "!":
                sent = GCM.shout(message.substr(1));
                break;
            case "$":
                sent = GCM.trade(message.substr(1));
                break;
            case "@":
                sent = GCM.clan(message.substr(1));
                break;
            case "#":
                sent = GCM.party(message.substr(1));
                break;
            case '"':
                sent = GCM.whisper(message.substr(1));
                if (sent) {
                    reset = message.substr(0, message.indexOf(" ") + 1);
                }
                break;
            case "~":
                sent = GCM.ally(message.substr(1));
                break;
            default:
                sent = GCM.say(message);
                reset = "";
        }

        if (sent) {
            this._text.text(reset);
        }
    }
}

ui.ChatBox = ChatBox;
ui.chatBox = function () {
    return new ui.ChatBox();
};
